import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "sunlounger",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "sun lounger",
    description: "sunlounger",
    image: require("./sunlounger.svg"),
    svgIcon: require("./sunlounger.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-19, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M69.8,8.53V9.8c1-.14.93.49.92,1.14,0,2.08,0,4.16,0,6.23,0,.63.11,1.32-.87,1.15-.1.53-.22.91.46,1,.16,0,.39.5.39.77,0,2.23,0,4.46,0,6.69,0,.68-.21,1-.89,1-.08.48-.23.89.45,1,.17,0,.4.43.41.67,0,2.35,0,4.7,0,7,0,.31-.44.61-.76.87-.15.34-.34.76.35.85.18,0,.41.43.42.67,0,2.35,0,4.69,0,7a1.46,1.46,0,0,1-.41.7,4.5,4.5,0,0,0-.61.76c1,.17,1.07.73,1,1.47,0,2,0,4.1,0,6.15,0,.5.11,1-.68,1.13-.14,0-.23.45-.41.8,1.05,0,1.12.62,1.1,1.36,0,2.08,0,4.16,0,6.23,0,.5,0,1-.67,1.06-.14,0-.24.43-.43.81,1.08,0,1.13.6,1.12,1.33,0,2.08,0,4.16,0,6.24,0,.63,0,1.2-1,1l0,.26c.19.23.4.46.58.7s.45.49.46.74c0,2.32,0,4.64,0,7,0,.33-.44.66-.77.94-.17.37-.27.76.4.84.15,0,.38.45.38.69,0,2.32,0,4.64,0,7,0,.33-.42.66-.65,1L69.77,94v1.53a.75.75,0,0,1-.89.86c-.24,0-.48,0-.72,0H30.21c-1.66,0-1.66,0-1.68-1.69V94c-.9,0-1-.57-1-1.33,0-2.08,0-4.16,0-6.24,0-.5,0-1,.68-1.06.16,0,.27-.45.49-.85-1.11,0-1.19-.52-1.18-1.24,0-2,0-4.1,0-6.15,0-.53-.12-1.13.72-1.19.1,0,.26-.31.25-.47s-.19-.4-.33-.41c-.64-.07-.65-.51-.65-1V67.43c0-.48,0-.92.66-1A.52.52,0,0,0,28.5,66c0-.19-.2-.47-.35-.49-.57-.09-.62-.47-.62-.92V57.94c0-.45,0-.83.62-.92a.66.66,0,0,0,.35-.48c0-.16-.26-.3-.39-.47s-.55-.56-.56-.84q-.06-3.39,0-6.78c0-.28.36-.57.56-.85s.38-.3.39-.46-.2-.46-.35-.48c-.58-.09-.62-.47-.62-.92V39.05c0-.45,0-.83.62-.92a.62.62,0,0,0,.35-.48c0-.16-.26-.31-.38-.47s-.56-.56-.56-.84c0-2.26,0-4.52,0-6.78,0-.47.1-.81.66-.88.13,0,.3-.33.31-.52a.52.52,0,0,0-.33-.4c-.59-.06-.64-.44-.64-.9,0-2.22,0-4.45,0-6.68,0-.73.36-.95,1.28-1-.35-.4-.55-.62-.74-.85s-.49-.48-.5-.72c0-2.35-.05-4.7,0-7,0-.33.49-.64.93-.85v-1c-1-.05-1-.74-1-1.51a22.07,22.07,0,0,0,0-2.44c-.05-.8.29-1,1.06-1,6.78,0,13.55,0,20.33,0h20.6c1.2,0,1.21,0,1.21,1.2,0,.85,0,1.69,0,2.53C70.73,8.05,70.76,8.68,69.8,8.53ZM29.33,57.16V95.37H69v-1q0-18.08,0-36.15c0-.87-.23-1.1-1.1-1.1q-18.8,0-37.59,0Zm0-29.77V56.65H69V27.39Zm0-.57H69v-18H29.31ZM70.13,4.42h-42V7.77h42ZM28.42,38.88H28.2v7h.22Zm-.21-21.32h.21v-7h-.21Zm0,9.44h.22V20H28.2Zm.24,2.46-.22,0v7h.22Zm-.25,25.87h.2v-7h-.2Zm.23,2.44h-.21v7h.21ZM28.2,83.65l.21,0v-7H28.2Zm.23,2.46h-.21v7h.21ZM70.09,20H69.9v7h.19Zm0,9.43H69.9v7h.19ZM69.86,45.9h.2v-7h-.2Zm.22,11.88h-.2v7h.2Zm0,9.45H69.9v7h.17Zm0-56.66h-.2v7h.2Zm0,37.77h-.16v7h.16ZM28.44,67.27h-.2v6.92h.2Zm41.64,9.41h-.2v7h.2Zm0,9.42H69.9v7h.18Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M29.33,57.16h1q18.8,0,37.59,0c.87,0,1.11.23,1.1,1.1q0,18.08,0,36.15v1H29.33Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M29.35,27.39H69V56.65H29.35Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M29.31,26.82v-18H69v18Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M70.13,4.42V7.77h-42V4.42Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M28.42,38.88v7H28.2v-7Z"
              transform="translate(-27.51 -3.66)"
            />
            <ellipse class="cls-1" cx="0.8" cy="10.41" rx="0.15" ry="4.95" />
            <path
              class="cls-1"
              d="M28.2,27V20h.22v7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M28.44,29.46v7h-.22v-7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M28.19,55.33v-7h.2v7Z"
              transform="translate(-27.51 -3.66)"
            />
            <ellipse class="cls-1" cx="0.8" cy="57.63" rx="0.15" ry="4.97" />
            <path
              class="cls-1"
              d="M28.2,83.65v-7h.21v7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M28.43,86.11v7h-.21v-7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M70.09,20v7H69.9V20Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M70.09,29.42v7H69.9v-7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M69.86,45.9v-7h.2v7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M70.08,57.78v7h-.2v-7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M70.07,67.23v7H69.9v-7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M70.07,10.57v7h-.2v-7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M70.07,48.34v7h-.16v-7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M28.44,67.27v6.91h-.2V67.26Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M70.08,76.68v7h-.2v-7Z"
              transform="translate(-27.51 -3.66)"
            />
            <path
              class="cls-1"
              d="M70.08,86.1v7H69.9v-7Z"
              transform="translate(-27.51 -3.66)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
